module.exports = __webpack_public_path__ + "static/waukeen-symbol-DND3_FnP-b9470c181a349ac9b2edd2d8d171b4f1.webp";